/*------------------------------------------------------------------
Import modules
------------------------------------------------------------------*/

// import { offset } from 'meteora';
import ScrollDir from "scrolldir";
import ScrollLocker from '../classes/scroll-locker';
import ScrollController from '../classes/scroll-control';

/*------------------------------------------------------------------
Scroll Direction
------------------------------------------------------------------*/

ScrollDir();

/*------------------------------------------------------------------
Scroll Controller
------------------------------------------------------------------*/

window.ScrollLocker = new ScrollLocker(document.querySelector('.body'));
window.ScrollController = new ScrollController();

// window.ScrollLocker.lock();

/*------------------------------------------------------------------
Scroll to links
------------------------------------------------------------------*/

const links = [...document.querySelectorAll('a')];
const wrapper = document.body;
wrapper.scrollTo(0, 0);
links.forEach(link => {
  if (link.hash) {
    // Find the target element
    const target = document.getElementById(link.hash.replace('#', ''));

    // If the target element exists
    if (target) {
      const element = target.firstElementChild || target;
      // Add the click event listener
      link.addEventListener('click', e => {
        e.preventDefault();
        window.ScrollController.scrollTo(Meteora.offset(element).y - 200);
      });
    }
  }
});

// If there is a hash in the URL
if (window.location.hash) {
  const target = document.getElementById(window.location.hash.replace('#', ''));
  const element = target ? target.firstElementChild || target : null;
  window.scrollTo(0, 0);
  setTimeout(() => {
    if (!element) return;
    // Scroll to the target element
    window.ScrollController.scrollTo(Meteora.offset(element).y - 200);
  }, 500);
}